import {Dispatch} from "redux";
import {setDataValue} from "../reducers/dataReducer";

export const getData = async (dispatch: Dispatch) => {
    try {
        const testData = [
            {
                category: 'Sushi set',
                data: [
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '22 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian', 'sushi', 'japanese', 'sushi', 'japanese', 'asian', 'sushi', 'asian', 'sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Dine-in'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-2.png`,
                        name: 'Sushi mix - 9 PC NIGIRI + 3 PC TEMPURA',
                        price: '300 kr',
                        discount: '175 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 7,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian', 'sushi', 'sushi', 'japanese', 'asian', 'sushi', 'japanese', 'asian', 'sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-3.png`,
                        name: 'Sushi mix - 3 pc Nigiri sushi 3 salmon 3 tuna + 4 roll',
                        price: '250 kr',
                        discount: '185 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 12,
                        validUntil: ['09:00', '11:30', '13:25', '16:15', '17:55'],
                        descriptionSpend: 'Mininum 220 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian', 'salmon', 'tuna'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-2.png`,
                        name: 'Sushi mix - 6 PC NIGIRI + 6 PC TEMPURA',
                        price: '150 kr',
                        discount: '80 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 11,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 250 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '350 kr',
                        discount: '275 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 14,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '350 kr',
                        discount: '275 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 14,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '350 kr',
                        discount: '275 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 14,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Dine-in'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Dine-in'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/sushi-1.png`,
                        name: '12 pc Nigiri sushi 6 salmon + 6 tuna',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 8,
                        validUntil: ['10:00', '16:30', '18:00', '22:00'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['sushi', 'japanese', 'asian'],
                        categoryName: 'Sushi set',
                        reservationStatus: 'Take-out'
                    },
                    ]
            },
            {
                category: 'Indian',
                data: [
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-1.png`,
                        name: 'Chickpea and couscous vegan curry',
                        price: '300 kr',
                        discount: '175 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 4,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['rise', 'curry', 'indian', 'asian'],
                        categoryName: 'indian',
                        reservationStatus: 'Dine-in'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                        name: 'Pumpkin cream soup with pink peppercorn',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 3,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['soup', 'indian', 'asian'],
                        categoryName: 'indian',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                        name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 11,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['chicken', 'indian', 'achari'],
                        categoryName: 'indian',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-1.png`,
                        name: 'Chickpea and couscous vegan curry',
                        price: '300 kr',
                        discount: '175 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 4,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['rise', 'curry', 'indian', 'asian'],
                        categoryName: 'indian',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                        name: 'Pumpkin cream soup with pink peppercorn',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 3,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['soup', 'indian', 'asian'],
                        categoryName: 'indian',
                        reservationStatus: 'Dine-in'
                    },
                ]
            },

            {
                category: 'Italian',
                data: [
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-1.png`,
                        name: 'Italian and couscous vegan curry',
                        price: '420 kr',
                        discount: '145 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 4,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['rise', 'curry', 'indian', 'asian'],
                        categoryName: 'italian',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                        name: 'Pumpkin cream soup with pink peppercorn',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 3,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['soup', 'indian', 'asian'],
                        categoryName: 'italian',
                        reservationStatus: 'Dine-in'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                        name: 'Achariii Murgh: Soy based chicken cooked with Indian pickling spices',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 11,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['chicken', 'indian', 'achari'],
                        categoryName: 'italian',
                        reservationStatus: 'Dine-in'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-1.png`,
                        name: 'Chickpea and couscous vegan curry',
                        price: '300 kr',
                        discount: '175 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 4,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['rise', 'curry', 'indian', 'asian'],
                        categoryName: 'italian',
                        reservationStatus: 'Dine-in'
                    },
                ]
            },

            {
                category: 'Mexican',
                data: [
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-1.png`,
                        name: 'Maxican and couscous vegan curry',
                        price: '420 kr',
                        discount: '145 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 4,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['rise', 'curry', 'indian', 'asian'],
                        categoryName: 'mexican',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-2.png`,
                        name: 'Pumpkin cream soup with pink peppercorn',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'SFB Minsk (0.6 km)',
                        available: 3,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['soup', 'indian', 'asian'],
                        categoryName: 'mexican',
                        reservationStatus: 'Take-out'
                    },
                    {
                        image: `${process.env.PUBLIC_URL}/testData/indian-3.png`,
                        name: 'Achari Murgh: Soy based chicken cooked with Indian pickling spices',
                        price: '200 kr',
                        discount: '150 kr',
                        place: 'Cort Adelers Gate 2, 0254 Oslo',
                        available: 11,
                        validUntil: ['09:00', '11:30', '13:25', '16:15'],
                        descriptionSpend: 'Mininum 300 kr spend',
                        descriptionContent: 'Take a culinary journey into Japanese food tradition prepared by our skilled chefs. And Enjoy this great discount.',
                        tags: ['chicken', 'indian', 'achari'],
                        categoryName: 'mexican',
                        reservationStatus: 'Take-out'
                    },
                ]
            },

        ];
        dispatch(setDataValue({ key: "isLoading", value: true}));
        //const response = await fetch('https://jsonplaceholder.typicode.com/posts');
        //const data = await response.json();
        //dispatch(setData(data));
        dispatch(setDataValue({ key: "data", value: testData}));

        return testData;
    } catch (e) {
        dispatch(setDataValue({ key: "error", value: 'Data loading error' }));
    } finally {
        dispatch(setDataValue({ key: "isLoading", value: false}));
    }
}

export const getSelectedData = async (dispatch: Dispatch, item: any) => {
    try {
        dispatch(setDataValue({ key: "isLoading", value: true}));
        dispatch(setDataValue({ key: "data", value: item}));

        return item;
    } catch (e) {
        dispatch(setDataValue({ key: "error", value: 'Data loading error' }));
    } finally {
        dispatch(setDataValue({ key: "isLoading", value: false}));
    }
}

export const getQuestionData = async (dispatch: Dispatch) => {
    try {
        const testData = [
            {
                topic: 'Payment',
                data: [
                    {
                        title: 'payment',
                        question: 'How can I pay?',
                        answer: 'You can pay with credit card, debit card, PayPal, Apple Pay, Google Pay, and other payment methods. If you have trouble adding a payment method for purchases in the App Store, iTunes Store, or Apple Books, you might need to contact your financial institution for more help.',
                    },
                    {
                        title: 'payment',
                        question: 'What payment methods do you accept?',
                        answer: 'We accept Visa, MasterCard, American Express, Discover, Diners Club, and JCB. Debit cards with a Visa or MasterCard logo are also accepted.',
                    },
                    {
                        title: 'payment',
                        question: 'How can I get a refund?',
                        answer: 'You can request a refund by contacting our support team.',
                    },
                    {
                        title: 'payment',
                        question: 'Where can I find general information about your company?',
                        answer: 'You can find general information about our company on our About page.',
                    }
                ]
            },
            {
                topic: 'Food',
                data: [
                    {
                        title: 'food',
                        question: 'Where can I find my receipt?',
                        answer: 'You can find your receipt in the email you received after you made your purchase. You can also find your receipt in your Account Settings.',
                    },
                    {
                        title: 'food',
                        question: 'Do you have a menu?',
                        answer: 'You can find our menu on our website.',
                    },
                    {
                        title: 'food',
                        question: 'How can I find out about food allergies?',
                        answer: 'You can find information about food allergies on our website.',
                    },
                    {
                        title: 'food',
                        question: 'Where can I find information about your food?',
                        answer: 'You can find information about our food on our website.',
                    }
                ]
            },
            {
                topic: 'Order',
                data: [
                    {
                        title: 'order',
                        question: 'How can I change my order?',
                        answer: 'You can change your order by contacting our support team.',
                    },
                    {
                        title: 'order',
                        question: 'How can I cancel my order?',
                        answer: 'You can cancel your order by contacting our support team.',
                    },
                    {
                        title: 'order',
                        question: 'How can I find out about my order?',
                        answer: 'You can find information about your order on our website.',
                    },
                    {
                        title: 'order',
                        question: 'How can I find out about my order?',
                        answer: 'You can find information about your order on our website.',
                    },
                    {
                        title: 'order',
                        question: 'Where can I find information about my order?',
                        answer: 'You can find information about your order on our website.',
                    }
                ]
            }
        ]
        return testData;
    } catch (e) {
        dispatch(setDataValue({ key: "error", value: 'Data loading error' }));
    } finally {
        dispatch(setDataValue({ key: "isLoading", value: false}));
    }
}